import { router } from '../core/router.js';
import { auth } from '../core/auth-store.js';

export class AppShell extends HTMLElement {
  private outlet!: HTMLElement;
  private cleanup: Array<() => void> = [];

  connectedCallback(): void {
    this.innerHTML = `
      <div id="impersonate-banner" class="impersonate-banner" style="display:none;">
        <span id="impersonate-text"></span>
        <button id="stop-impersonate" class="btn btn-secondary btn-sm">Zakończ</button>
      </div>
      <app-nav></app-nav>
      <div id="app-outlet"></div>
      <style>
        #app-outlet {
          min-height: 100vh;
        }
        #app-outlet.has-topbar {
          padding-top: var(--header-height);
        }
        #app-outlet.has-sidebar {
          padding-bottom: 64px;
        }
        @media (min-width: 800px) {
          #app-outlet.has-sidebar { margin-left: var(--nav-width); padding-bottom: 0; }
        }
        .impersonate-banner {
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          z-index: 200;
          height: var(--header-height);
          background: var(--color-warning-bg, #fff3cd);
          color: var(--color-warning, #856404);
          padding: 0 var(--space-md);
          display: flex;
          align-items: center;
          justify-content: center;
          gap: var(--space-sm);
          font-size: .9rem;
          font-weight: 600;
          border-bottom: 2px solid var(--color-warning, #856404);
        }
        .impersonate-banner .btn-sm { padding: 4px 12px; font-size: .8rem; }
        .impersonate-active .top-bar { display: none; }
        @media (min-width: 800px) {
          .impersonate-banner { left: var(--nav-width); }
        }
      </style>
    `;
    this.outlet = this.querySelector('#app-outlet')!;
    this.outlet.classList.add('has-topbar', 'has-sidebar');
    router.setOutlet(this.outlet);

    // Impersonate banner events
    this.querySelector('#stop-impersonate')!.addEventListener('click', () => {
      if (!router.canLeave()) return;
      auth.stopImpersonating();
      location.hash = '#/admin/people';
    });

    // Listen for auth changes to show/hide banner
    this.cleanup.push(auth.subscribe(() => this.updateBanner()));

    // Wait for auth to initialize, then start routing
    auth.initialize().then(() => {
      router.start();
    });
  }

  disconnectedCallback(): void {
    this.cleanup.forEach(fn => fn());
  }

  private updateBanner(): void {
    const banner = this.querySelector('#impersonate-banner') as HTMLElement;
    const text = this.querySelector('#impersonate-text') as HTMLElement;

    // Sidebar always present (nav shown for both logged-in and public)

    if (auth.isImpersonating) {
      banner.style.display = 'flex';
      text.textContent = `Działasz jako: ${auth.impersonatedName}`;
      this.classList.add('impersonate-active');
    } else {
      banner.style.display = 'none';
      this.classList.remove('impersonate-active');
    }
  }
}

customElements.define('app-shell', AppShell);
